import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataContact } from '../types/entities/contact';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_CONTACT = defineMasterdataEntity<MasterdataContact>({
  name: 'contact',
  responseKey: 'contact',
  displayWith: (c) => keyName(c.key, c.name),
  secondaryWith: (c) => c.email ?? c.description,
  defaultFilter: ACTIVE_ONLY,
  icon: 'fa-regular fa-address-book',
  title: 'Kontaktsuche',
  label: 'Kontakte',
  placeholder: 'Kontakte suchen...',
  columns: [
    {
      label: 'Kontakte',
      type: 'entity',
      icon: 'fa-regular fa-address-book',
      value: (e) => keyName(e.key, e.name),
      secondary: (e) => e.email ?? e.description,
    },
    { label: 'Schlüssel', type: 'text', value: (e) => e.key },
    { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    { label: 'E-Mail', type: 'text', value: (e) => e.email },
    { label: 'Beschreibung', type: 'text', value: (e) => e.description },
    { label: 'Aktiv', type: 'text', value: (e) => (e.active ? 'Ja' : 'Nein') },
    { label: 'Laufende Nummer', type: 'text', value: (e) => e.sequentialNumber },
  ],
});
